var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeemgIconsVideoWhite2023(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1101 10.21C8.92007 10.21 6.32007 12.81 6.32007 16C6.32007 19.19 8.92007 21.79 12.1101 21.79C15.3001 21.79 17.9001 19.19 17.9001 16C17.9001 12.81 15.3001 10.21 12.1101 10.21ZM12.1101 20.91C9.40007 20.91 7.20007 18.71 7.20007 16C7.20007 13.29 9.40007 11.09 12.1101 11.09C14.8201 11.09 17.0201 13.29 17.0201 16C17.0201 18.71 14.8201 20.91 12.1101 20.91Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6201 8.91001L22.42 11.49V10.66C22.42 7.92001 20.19 5.70001 17.46 5.70001H6.76005C4.02005 5.70001 1.80005 7.93001 1.80005 10.66V21.35C1.80005 24.09 4.03005 26.32 6.76005 26.32H17.45C20.19 26.32 22.41 24.09 22.41 21.35V20.52L29.6 23.09C29.73 23.14 29.89 23.12 30 23.04C30.12 22.96 30.1901 22.82 30.1901 22.68V9.32001C30.1901 9.18001 30.12 9.04001 30.01 8.96001C29.9 8.88001 29.7501 8.86001 29.6201 8.91001ZM21.5401 21.35C21.5401 23.6 19.71 25.44 17.45 25.44H6.76005C4.51005 25.44 2.67005 23.61 2.67005 21.35V10.65C2.67005 8.40001 4.50005 6.56001 6.76005 6.56001H17.45C19.7 6.56001 21.5401 8.39001 21.5401 10.65V21.35ZM29.32 22.05L22.42 19.58V12.42L29.32 9.95001V22.05Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeemgIconsVideoWhite2023);
export default __webpack_public_path__ + "static/media/beemg-icons-video-white-2023.532965f2ca5f04b9d6417d64130d45b8.svg";
export { ForwardRef as ReactComponent };